class SignaturesController {
  constructor() {
    this.load()
  }

  load() {
    this.loadSignatureIfCreationInProgress()
    this.showScreenshots()
    this.forceUpdateGmailSignature()
    this.displayInputForSocialNetwork()
    this.linkTogglesTarget()
    this.appointmentBtnForm()
    this.hideEmptySocialNetworks()
  }

  hideEmptySocialNetworks() {
    var selector = $(".js-social-networks input")
    selector.each(function () {
      var selected_div = $(this).parent("div"),
        network_name = selected_div.children("label").html().toLowerCase()
      if ($(this).val().length === 0) {
        selected_div.hide()
      } else {
        $(".js-" + network_name).hide()
      }
    })
  }

  appointmentBtnForm() {
    var appointmentInputs = $(".js-appointment_inputs")

    var appointmentTextInput = $(".js-appointment_text_input")[0]
    // Alert if input is too long for meeting btn
    $(appointmentTextInput).on("input", function () {
      if (
        appointmentInputs.is(":visible") &&
        appointmentTextInput.value.length > 25
      ) {
        appointmentTextInput.style.borderColor = "#cc0000"
        appointmentTextInput.style.color = "#cc0000"
      } else {
        appointmentTextInput.style.color = ""
        appointmentTextInput.style.borderColor = ""
      }
    })
  }

  linkTogglesTarget() {
    $.each($(".js-toggle-target-visibility"), function (index, el) {
      var toggleVisibilityCheckbox = $($(this)[0])
      if (toggleVisibilityCheckbox == undefined) {
        return
      }
      var target = toggleVisibilityCheckbox.data().target

      var targetInputs = $(target)

      toggleVisibilityCheckbox.change(function () {
        if (this.checked) {
          targetInputs.removeClass("d-none")
        } else {
          $.each($("input", targetInputs), function (index, el) {
            $(el).val("")
          })
          //appointmentLinkInput.value = ""
          targetInputs.addClass("d-none")
        }
      })

      toggleVisibilityCheckbox.change()
    })
  }

  displayInputForSocialNetwork() {
    $("select.js-social-network-select").change(function () {
      var network_name = this.value.toLowerCase()
      var div_to_display = $(".organization_" + network_name)
      if (div_to_display.length == 0) {
        div_to_display = $(".signature_" + network_name)
      }
      $(".js-" + network_name).hide()
      $(".add-other-network").before(div_to_display)
      div_to_display.show(500)
    })
  }

  forceUpdateGmailSignature() {
    $(".js-force-update-gmail-signature").click(function () {
      $.ajax($("#js-address_for_update_time").html())
    })

    $(".js-force-read-gmail-signature").click(function () {
      $.ajax($("#js-address_for_read").html())
    })
  }

  showScreenshots() {
    $(".js-notice-toggle").on("click", function (e) {
      var link_href = $($.attr(this, "href"))
      var offset = $(this).offset().top //+ $(window).height()/2;

      $(".hide_before_js").hide()
      $(".notices").show()
      var displayMethod = "block"
      if ($(this).hasClass("js-display-flex")) {
        displayMethod = "flex"
      }
      link_href.css("display", displayMethod)

      $("html, body").animate(
        {
          scrollTop: offset,
        },
        500
      )

      e.preventDefault()
    })
  }

  loadSignatureIfCreationInProgress() {
    if ($(".js-signature-creation-in-progress").length > 0) {
      var url = $("#get_signature_path").html()
      this._loadSignatureIfNotDirty(url)
    }
  }

  _loadSignatureIfNotDirty(signatureUrl) {
    var self = this
    $.get(signatureUrl, function (data) {
      $("#get_signature_path").append("done")
      if (data.dirty_picture || data.dirty_avatar) {
        setTimeout(function () {
          self._loadSignatureIfNotDirty(signatureUrl)
        }, 500)
      } else {
        $.get($("#get_signature_html_path").text(), function (data) {
          $(".signature.js-signature").html(data)
        })
      }
    })
  }

  // Remove DUPLICATE CODE (announcement controller)
  _loadPreviewIfNotDirty(preview_url) {
    $.get(preview_url, (data) => {
      if (data.dirty_preview) {
        setTimeout(() => {
          this._loadPreviewIfNotDirty(preview_url)
        }, 500)
      } else {
        var url = $("#get_preview_path").text()

        if (url.length) {
          $.get(url, function (data) {
            console.log(data)

            if (data.url) {
              $(".announcement-preview.js-announcements").html(
                "<img src =" + data.url + ", height=260, width=450>"
              )
            } else {
              // document.location.reload();
            }
          })
        }
      }
    })
  }
}

export { SignaturesController }
